"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateDateRangeFieldValue = exports.getDateRangeFieldEmptyValue = void 0;
const getDateRangeFieldEmptyValue = () => {
    return {
        from_date: {
            date: null,
            include_time: false,
        },
        to_date: {
            date: null,
            include_time: false,
        },
    };
};
exports.getDateRangeFieldEmptyValue = getDateRangeFieldEmptyValue;
const generateDateRangeFieldValue = (value) => {
    return { ...(0, exports.getDateRangeFieldEmptyValue)(), ...value };
};
exports.generateDateRangeFieldValue = generateDateRangeFieldValue;
